import { useRecoilValue } from "recoil";
import { userAtom } from "../recoil/userAtom";

/**
 * Home 에서는 사용 금지
 * user context 업데이트 전임.
 */
export default function useRole() {
  const user = useRecoilValue(userAtom);

  const isCoach =
    user?.accessToken !== undefined &&
    user?.role !== undefined &&
    user?.role !== "patient";

  const isPatient =
    user?.accessToken !== undefined &&
    user?.role !== undefined &&
    user?.role === "patient";

  const isAdmin =
    user?.accessToken !== undefined &&
    user?.role !== undefined &&
    user?.role === "admin";

  const isEarlyAccessCoach =
    user?.accessToken !== undefined &&
    user?.role !== undefined &&
    user?.role !== "patient" &&
    user?.isEarlyAccess;

  return {
    isPatient,
    isCoach,
    isAdmin,
    isEarlyAccessCoach,
  };
}